import Box from '@/components/UI/Box';

export default function ActionBar({ children }: { children: React.ReactNode }) {
  return (
    <Box direction="horizontal" space="md" py="md" px="lg" wrap>
      {children}
    </Box>
  );
}
